import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { WorkspaceProvider } from "@/contexts/WorkspaceContext";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import Sidebar from "@/components/Sidebar";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Templates from "@/pages/Templates";
import Chat from "@/pages/Chat";
import Audits from "@/pages/Audits";
import AIAssistant from "@/pages/AIAssistant";
import Notifications from "@/pages/Notifications";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import HotelWebsite from "@/pages/HotelWebsite";
import { Toaster } from "sonner";

function ProtectedLayout() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return (
    <WorkspaceProvider>
      <div className="min-h-screen bg-[#0B0B0E]">
        <Sidebar />
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </WorkspaceProvider>
  );
}

function PublicHome() {
  const { user } = useAuth();
  if (user) return <Navigate to="/home" replace />;
  return <Landing />;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme === "light" ? "light" : "dark"} position="top-right" />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <ThemedToaster />
            <Routes>
              <Route path="/" element={<PublicHome />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route element={<ProtectedLayout />}>
                <Route path="/home" element={<Home />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:projectId" element={<ProjectDetail />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/audits" element={<Audits />} />
                <Route path="/ai-assistant" element={<AIAssistant />} />
                <Route path="/hotel-website" element={<HotelWebsite />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/admin" element={<Admin />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
